import React from "react";
import { UsagePlan } from "pages/subscription/SubscriptionStyled";
import {
  CommonTable,
  ExpandTableContainer,
} from "components/atoms/table/AntdTable";
import { TableColumnsType } from "antd";
import { BasePagination } from "api/interfaces/commonInterface.interface";
import { PlanEuListDto } from "api/interfaces/planInterface.interface";

interface Props {
  columns: TableColumnsType<PlanEuListDto>;
  data: PlanEuListDto[];
  isLoading: boolean;
  queryInfo: BasePagination;
  onChangePage: (page: number, totalRows: number) => void;
}

export default function PlanOrganizationPresenter(props: Props) {
  return (
    <UsagePlan.Wrapper>
      <ExpandTableContainer>
        <CommonTable
          columns={props.columns}
          dataSource={props.data}
          queryInfo={props.queryInfo}
          onChangePage={props.onChangePage}
          loading={props.isLoading}
          rowKey="accountId"
        />
      </ExpandTableContainer>
    </UsagePlan.Wrapper>
  );
}
